import styled, { css } from 'styled-components';

import { theme } from '../layout/theme';
import { size, rgba } from '../layout/helpers';

import { Container } from '../Container/wrapper';

// CSS used to style `Grid` in overflow scroll layout
const GridOverflow = css`
  position: relative;
`;

export const Grid = styled.div`
  background-color: ${theme.colors.bg.productListing};
  &.overflow-scroll-always,
  &.overflow-scroll-ltmd {
    ${GridOverflow}
  }

  &.ignore-container-lt-md {
    ${theme.screens.LtMd} {
      ${Container} & {
        margin: 0 -${theme.distances.containerGutter};
      }
    }
  }
`;

export const GridNav = styled.div`
  position: absolute;
  top: 50%;
  z-index: 49;

  &.dir-prev {
    left: 0;
    transform: translate(-50%, -50%);
  }

  &.dir-next {
    right: 0;
    transform: translate(50%, -50%);
  }

  ${theme.screens.LtMd} {
    display: none;
  }
`;

// CSS used to style `List` in overflow scroll layout
const ListOverflow = css`
  flex-wrap: nowrap;
  -webkit-overflow-scrolling: touch;
  scroll-padding-left: 1px; // width of border
  scroll-padding-right: 1px; // width of border
`;

export const List = styled.ul`
  display: grid;
  list-style: none;
  justify-content: space-between;
  padding: 0;
  margin: 0;
  grid-template-columns: repeat(2, 1fr);

  &.horizontal-view {
    overflow-x: scroll;
    grid-auto-flow: column;
    grid-gap: ${size(3)};
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  ${theme.screens.Sm} {
    grid-gap: ${size(1)};
    grid-template-columns: repeat(3, 1fr);
  }
  ${theme.screens.Md} {
    grid-gap: ${size(1)};
    grid-template-columns: repeat(4, 1fr);
  }

  &.grid-small {
    grid-gap: ${size(3)};

    grid-template-columns: repeat(4, 1fr);
    ${theme.screens.LtSm} {
      grid-gap: ${size(1)};
      grid-row-gap: ${size(2)};
      grid-template-columns: repeat(2, 3fr);
    }
    ${theme.screens.SmLtMd} {
      grid-gap: ${size(1)};
      grid-row-gap: ${size(2)};
      grid-template-columns: repeat(3, 3fr);
    }
    ${theme.screens.MdLtLg} {
      grid-gap: ${size(2)};
      grid-template-columns: repeat(3, 3fr);
    }
  }
  &.grid-large {
    grid-gap: ${size(3)};
    grid-template-columns: repeat(1, 1fr);
    ${theme.screens.Sm} {
      grid-template-columns: repeat(3, 1fr);
    }
    ${theme.screens.LtSm} {
      grid-gap: ${size(1)};
      margin: 0 ${size(3)};
    }
    ${theme.screens.SmLtMd} {
      grid-gap: ${size(1)};
      grid-template-columns: repeat(2, 3fr);
    }
    ${theme.screens.MdLtLg} {
      grid-gap: ${size(2)};
      grid-template-columns: repeat(2, 3fr);
    }
  }

  &.center-items {
    justify-content: center;
  }

  ${theme.screens.LtMd} {
    &::-webkit-scrollbar {
      -webkit-appearance: none;
      height: ${size(2.25)};
    }

    &::-webkit-scrollbar-track {
      background-color: ${rgba(theme.colors.bg.alt, 0.1)};
      height: ${size(0.25)};
      border-top: ${size(2)} solid transparent;
      background-clip: padding-box;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.bg.alt};
      height: ${size(0.25)};
      border-top: ${size(2)} solid transparent;
      background-clip: padding-box;
    }

    ${Container} & {
      &::-webkit-scrollbar-track {
        border: ${theme.distances.containerGutter} solid transparent;
        border-bottom: none;
      }

      &::-webkit-scrollbar-thumb {
        border: ${theme.distances.containerGutter} solid transparent;
        border-bottom: none;
      }
    }
  }

  &.overflow-scroll-always {
    overflow: auto;

    @supports (-moz-appearance: none) {
      overflow: hidden;
    }

    scroll-snap-type: x mandatory;

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      height: 0;
    }
  }

  .overflow-scroll-ltmd & {
    ${theme.screens.LtMd} {
      ${ListOverflow}

      overflow: auto;
    }
  }
`;

// CSS used to style `Item` in overflow scroll layout
const ItemOverflow = css`
  border-left: none;
  scroll-snap-align: start;
`;

export const Item = styled.li`
  min-width: 0;
  .overflow-scroll-always & {
    ${ItemOverflow}
    width: 300px;
    ${theme.screens.LtMd} {
      width: 260px;
      max-width: 260px;
    }
  }
`;

export const ProductsWrapper = styled.div`
  background-color: ${theme.colors.bg.productListing};
`;

export const ProductsViewContainer = styled.div`
  padding-top: ${size(4)};
  width: 100%;
  max-width: ${theme.distances.containerMaxWidth};
  margin-left: auto;
  margin-right: auto;
  padding-left: ${theme.distances.containerGutter};
  padding-right: ${theme.distances.containerGutter};
  padding-bottom: ${size(1)};

  ${theme.screens.Md} {
    &:not(.in-panel) {
      padding-left: ${theme.distances.containerGutterMd};
      padding-right: ${theme.distances.containerGutterMd};

      &.limit-width {
        max-width: ${theme.distances.contentMaxWidth};
        margin-left: auto;
        margin-right: auto;
      }
    }
    &.in-panel {
      padding-left: ${size(3)};
      padding-right: ${size(3)};
    }
  }
  ${theme.screens.Sm} {
    padding-left: 0;
    padding-right: 0;
  }
  ${theme.screens.XS} {
    padding-left: 0;
    padding-right: 0;
  }
  ${theme.screens.XXS} {
    padding-left: 0;
    padding-right: 0;
  }
`;
